import * as React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SourceDocument } from '../types';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { MuiMarkDown } from './MuiMarkdown';
import { getDocumentTitleFromSource, getDocumentUrl } from '../tools';
import { DocumentReferenceFeedback } from './DocumentReferenceFeedback';
import { ReportMissingDocument } from './ReportMissingDocument';

interface Props {
  sourceDocuments: SourceDocument[] | null;
  cuid: string;
  quid: string;
}

const handleDocumentOpen =
  (url: string, queryTemplate: string | null, page: number | null) => () => {
    window.open(getDocumentUrl(url, queryTemplate, page), '_blank')?.focus();
  };

export const References: React.FC<Props> = ({
  sourceDocuments,
  cuid,
  quid,
}) => {
  return (
    <>
      {sourceDocuments?.map(
        (
          {
            page,
            page_content,
            source,
            uc_doc_title,
            uc_doc_title_per_owner,
            uc_doc_subtitle,
            uc_doc_view_url_per_owner,
            uc_doc_view_url_pg_target,
            uc_doc_id,
          },
          i,
        ) => {
          const title =
            uc_doc_title_per_owner ||
            uc_doc_title ||
            uc_doc_subtitle ||
            getDocumentTitleFromSource(source);
          return (
            <Accordion
              elevation={0}
              key={i}
              disableGutters
              sx={{
                '& p, & strong': {
                  //use sx and select related class
                  fontSize: '14px', // change its style
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Stack alignItems="center" flex={1} direction="row" spacing={1}>
                  <PictureAsPdfIcon fontSize="small" color="action" />
                  <Typography>{title}</Typography>
                  <Typography
                    noWrap
                    textOverflow="initial"
                    variant="overline"
                    pr={1}
                    pl={1}
                  >
                    page {page}
                  </Typography>
                </Stack>
              </AccordionSummary>
              <AccordionDetails>
                <Stack gap={1}>
                  <MuiMarkDown mdContent={page_content} />
                  <DocumentReferenceFeedback
                    ucDocId={uc_doc_id}
                    quid={quid}
                    cuid={cuid}
                  />
                  <Stack gap={1} justifyContent="end" direction="row">
                    {!!uc_doc_view_url_per_owner && (
                      <Button
                        onClick={handleDocumentOpen(
                          uc_doc_view_url_per_owner,
                          uc_doc_view_url_pg_target,
                          page,
                        )}
                        variant="contained"
                      >
                        View document
                      </Button>
                    )}
                  </Stack>
                </Stack>
              </AccordionDetails>
            </Accordion>
          );
        },
      )}
      <Stack paddingTop={2} justifyContent="end" direction="row">
        <ReportMissingDocument label="Reference" />
      </Stack>
    </>
  );
};
